"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STRICT_EMAIL = void 0;
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _restrictInput = require("../normalizers/restrictInput");
var _regex = require("../regex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var formValidationInvalidEmail = 'Please make sure your email format is correct';
var EMAIL = {
  component: _Input["default"],
  type: 'email',
  name: 'email',
  label: 'Email',
  id: 'email',
  required: true,
  maxLength: 40,
  regex: _regex.emailRegex,
  validationMessageKeys: {
    required: 'Please enter an email address',
    maxLength: 'Sorry, your email address is longer than we can accept. Please try using a different one',
    regex: formValidationInvalidEmail
  },
  normalize: _restrictInput.asciiOnlyEmail,
  autoComplete: 'email',
  /**
   * https://github.com/facebook/react/issues/6368
   * Need to manually ignore spaces.
   * Browsers automatically trim input.type = 'email' field values
   * Therefore a change event is not fired in React
   * and we can't restrict spaces via our normalizer
   */
  extensionProps: {
    // TODO make this anonymous function testable
    onKeyDown: function onKeyDown(e) {
      if (e.key === ' ') {
        e.preventDefault();
      }
    }
  }
};

// TODO make these anonymous functions testable
var STRICT_EMAIL = exports.STRICT_EMAIL = _objectSpread(_objectSpread({}, EMAIL), {}, {
  regex: [{
    pattern: _regex.emailInvalidExtensionRegex,
    message: 'emailExtension',
    // Get everything after the last dot
    getStringSegment: function getStringSegment(value) {
      if (value.indexOf('@') > 0) {
        return value.substr(value.lastIndexOf('.') + 1);
      }
      return null;
    }
  }, {
    pattern: _regex.strictEmailRegex,
    message: 'strictEmailRegex'
  }],
  validationMessageKeys: _objectSpread(_objectSpread({}, EMAIL.validationMessageKeys), {}, {
    strictEmailRegex: formValidationInvalidEmail,
    emailExtension: 'Please make sure your email format is correct (e.g. .co.uk or .com)'
  }),
  didYouMean: {
    set: ['yahoo.com', 'yahoo.co.uk', 'hotmail.com', 'hotmail.co.uk', 'gmail.com', 'outlook.com', 'btinternet.com', 'icloud.com', 'live.co.uk', 'blueyonder.co.uk', 'sky.com', 'sky.co.uk', 'googlemail.com', 'johnlewis.co.uk', 'talktalk.net', 'tiscali.co.uk', 'o2.co.uk', 'ntlworld.co.uk', 'ntlworld.com', 'ymail.com', 'aol.com', 'virginmedia.co.uk', 'virginmedia.com',
    // these are required so that we can push them through to the commonMistakes below
    'gmail.co.uk', 'gmail.ie', 'icloud.me', 'outlook.co.uk', 'tiscali.com'],
    commonMistakes: {
      'gmail.co.uk': 'gmail.com',
      'gmail.ie': 'gmail.com',
      'icloud.me': 'icloud.com',
      'outlook.co.uk': 'outlook.com',
      'tiscali.com': 'tiscali.co.uk'
    },
    preprocess: function preprocess(value) {
      if (value.indexOf('@') > -1) {
        return value.split('@')[1];
      }
      return null;
    },
    postprocess: function postprocess(suggestion, originalValue) {
      if (originalValue.indexOf('@') > -1) {
        return "".concat(originalValue.split('@')[0], "@").concat(suggestion);
      }
      return null;
    },
    threshold: 0.75
  }
});
var _default = exports["default"] = EMAIL;